const getHostListResponse = (response) => {
  const users = response?.users?.map((item) => {
    return {
      value: item?.id,
      label: item?.name,
    };
  });

  return users;
};

export default getHostListResponse;
